import React from 'react';

interface Props {
  values: number[];
  color: string;
  width?: number;
  height?: number;
  // Barras en vez de línea (lluvia: se suma, no se interpola).
  bars?: boolean;
}

// Mini gráfico sin ejes para las tarjetas del home — SVG a mano en vez de
// Recharts porque son cuatro a la vez y solo necesitan la forma de la curva.
const Sparkline: React.FC<Props> = ({ values, color, width = 120, height = 32, bars = false }) => {
  if (values.length < 2) return <svg width="100%" height={height} aria-hidden="true" />;

  const max = Math.max(...values);
  const min = bars ? 0 : Math.min(...values);
  const span = max - min || 1;
  const pad = 2;
  const x = (i: number) => (i / (values.length - 1)) * (width - pad * 2) + pad;
  const y = (v: number) => height - pad - ((v - min) / span) * (height - pad * 2);

  if (bars) {
    const barWidth = Math.max(1.5, (width - pad * 2) / values.length - 1);
    return (
      <svg viewBox={`0 0 ${width} ${height}`} width="100%" height={height} preserveAspectRatio="none" aria-hidden="true">
        {values.map((v, i) =>
          v > 0 ? (
            <rect
              key={i}
              x={pad + (i * (width - pad * 2)) / values.length}
              y={y(v)}
              width={barWidth}
              height={height - pad - y(v)}
              rx={1}
              fill={color}
            />
          ) : null
        )}
        <line x1={pad} x2={width - pad} y1={height - pad} y2={height - pad} stroke={color} strokeOpacity={0.25} />
      </svg>
    );
  }

  const points = values.map((v, i) => `${x(i)},${y(v)}`).join(' ');
  const area = `${pad},${height - pad} ${points} ${width - pad},${height - pad}`;
  return (
    <svg viewBox={`0 0 ${width} ${height}`} width="100%" height={height} preserveAspectRatio="none" aria-hidden="true">
      <polygon points={area} fill={color} fillOpacity={0.12} />
      <polyline points={points} fill="none" stroke={color} strokeWidth={1.75} strokeLinejoin="round" strokeLinecap="round" vectorEffect="non-scaling-stroke" />
    </svg>
  );
};

export default Sparkline;
